/* GAP configurator links (Ugur, 2026-10-27). Product, collage and gift pages link straight to their own card:
   ?product=<card name as a slug> opens that card (a collage template opens its Framed / Dibond / Canvas choice),
   ?group=<framed|frameless|print|gifts|magnetic> opens a group's list, and ?effect=<watercolour|pencil|pop-art> picks that photo
   effect once the photo is in. A hidden card or an unknown name shows the usual product list, which also stays for Back
   and for the menu link. */
/* 2026-10-29: the phone effect step and the rule that the art effect buttons show only for ?effect= links live in
   gap-configurator-effect-step.js, loaded from here so no template needs a new script tag. The same goes for
   gap-configurator-art.js (gallery artwork orders, ?art=: no orientation buttons, no custom size). */
/* 2026-10-30: collage-fit (collage editor size, Done at the bottom on wide screens) and gift-groups (Gifts list in three parts). */
/* 2026-10-31: cart-preview (the cart thumbnail shows the final framed / mounted look). frames (real 22x22 profile photos for Black / White / Oak in the preview and On-wall view). picker (square photo cards in the first step; the magnetic group is shown as Magnetic prints, the card is found by either name). */
/* 2026-11-01: sets (a Photo tile sets card in the Magnetic prints list that opens the set builder). 2026-11-02: gate (no default picks, flashing boxes, steps in order for the plain print products). */
(function () {
  try {
    var me = document.querySelector('script[src*="gap-configurator-link.js"]');
    if (me && me.src) {
      ['effect-step', 'art', 'collage-fit', 'gift-groups', 'cart-preview', 'frames', 'picker', 'sets', 'gate'].forEach(function (n) {
        var s = document.createElement('script'); s.src = me.src.replace('gap-configurator-link.js', 'gap-configurator-' + n + '.js').replace(/\?v=[^&]*/, '?v=' + Date.now()); document.body.appendChild(s);
      });
    }
  } catch (e) {}
})();
(function () {
  var qs; try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
  var want = qs.get('product'), group = qs.get('group'), effect = qs.get('effect');
  if (!want && !group && !effect) return;
  var GROUP = { framed: 'Framed print', frameless: 'Frameless print', print: 'Print only', gifts: 'Gifts', magnetic: 'Magnetic wall art' };
  function slug(x) { return String(x).toLowerCase().replace(/[’']/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  /* the same groups as the configurator's first step */
  function groupOf(p) {
    if (p.look === 'gift' || (window.gapcfgRules && window.gapcfgRules(p))) return 'gifts';
    if (p.look === 'magnetic' || /^magnetic/i.test(p.label)) return 'magnetic';
    return p.look === 'frame' ? 'framed' : (p.look === 'art' ? 'print' : 'frameless');
  }
  function cards() { return [].slice.call(document.querySelectorAll('[data-gapcfg] .gapcfg__pcard')); }
  function named(sel, text) { var alt = text === 'Magnetic wall art' ? 'Magnetic prints' : text; return cards().filter(function (c) { var n = c.querySelector(sel); return n && (n.textContent === text || n.textContent === alt); })[0]; }
  function open() {
    var D; try { D = JSON.parse(document.querySelector('[data-gapcfg-data]').textContent); } catch (e) { return; }
    var p = want ? D.products.filter(function (x) { return x.ok && slug(x.label) === slug(want); })[0] : null;
    var gid = p ? groupOf(p) : (GROUP[group] ? group : null);
    if (!gid) return;
    /* through the cards themselves, so every script's own handling runs (a group with one product opens it directly) */
    var gc = named('.gapcfg__gtext b', GROUP[gid]); if (gc) gc.click();
    var c = p && named('.gapcfg__pname', p.label); if (c) c.click();
  }
  if (want || group) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', open); else setTimeout(open, 0); }
  var file = document.querySelector('[data-gapcfg] [data-file]');
  if (effect && file) file.addEventListener('change', function once() {
    file.removeEventListener('change', once);
    /* the effect buttons appear with the photo; press the one the link asked for */
    setTimeout(function () {
      var b = [].filter.call(document.querySelectorAll('.gapai .gapai__b'), function (x) { return slug(x.textContent).replace(/-/g, '') === slug(effect).replace(/-/g, ''); })[0];
      if (b && !b.disabled && b.offsetParent) b.click();
    }, 400);
  });
})();
